/* lua.js generated code 0.3.0 */

HomeConfigManager = xClass("HomeConfigManager")
HomeConfigManager.prototype.ctor = function () {
    var self = this
    self.page_configs = table()
    self.page_configs_cache = table()
    self.pageHeights = 0
    self.page_anims = null
    self.page_anim_inits = table()
    self.unlockMainConfig = table()
}
HomeConfigManager.prototype.addPageConfig = function (page, page_data, isCache) {
    var self = this
    assert(isCache && self.page_configs[page] || page === $len(self.page_configs) + 1)
    if (isCache) {
        self.page_configs_cache[page] = page_data
    } else {
        self.page_configs[page] = page_data
    }
    self.updateData(page)
}
HomeConfigManager.prototype.addPageAnim = function (page) {
    var self = this
    if (!self.page_anims) {
        self.page_anims = require("clover/scene/component/homescene/HomeSceneAnims")
    }
    if (!self.page_anim_inits[page]) {
        self.page_anim_inits[page] = true
        self.updateAnimData(page)
    }
}
HomeConfigManager.prototype.getPageConfig = function (page) {
    var self = this
    var data = self.page_configs_cache[page]
    if (data) {
        return data
    }
    return self.page_configs[page]
}
HomeConfigManager.prototype.getPageAnim = function (page) {
    var self = this
    self.addPageAnim(page)
    return self.page_anims[page] || table()
}
HomeConfigManager.prototype.loadByPath = function (path) {
    var self = this
    let config = cc.loader.getRes(path);
    assert(config)
    var pre = string.split(path, "/")
    pre = pre[$len(pre)]
    pre = string.split(pre, ".")[1]
    pre = string.split(pre, "_")
    pre = pre[$len(pre)]
    pre = tonumber(pre)
    self.addPageConfig(pre, config)
}
HomeConfigManager.prototype.pushConfig = function (config_json, page) {
    var self = this
    var page = tonumber(page)
    assert(page)
    assert(page <= $len(self.page_configs))
    var config = table.deserialize(config_json)
    assert(config)
    self.addPageConfig(page, config, true)
}
HomeConfigManager.prototype.getPageCount = function () {
    var self = this
    return $len(self.page_configs)
}
HomeConfigManager.prototype.updateData = function (page) {
    var self = this
    var min_y = 0
    var $limit19 = page - 1
    for (var i = 1; i <= $limit19; i += 1) {
        min_y = min_y + self.getPageConfig(i).scene_height
    }
    var $var21 = page,$limit22 = self.getPageCount()
    for (var i = $var21; i <= $limit22; i += 1) {
        var pageConfig = self.getPageConfig(i)
        for (var k in pageConfig.other_datas) {
            var v = pageConfig.other_datas[k]
            if(!v){
                continue
            }
            addToObjRef(v)
            v.name = pageConfig.resource[v.name]
            v.res_name = pageConfig.resource[v.res_name]
            v.y_g = v.y + min_y
            v.y_g_min = v.y_g - v.h / 2
            v.y_g_max = v.y_g + v.h / 2
        }
        for (var k in pageConfig.lv_datas) {
            var v = pageConfig.lv_datas[k]
            if(!v){
                continue
            }
            addToObjRef(v)
            v.name = pageConfig.resource[v.name]
            v.res_name = pageConfig.resource[v.res_name]
            v.y_g = v.y + min_y
            v.y_g_min = v.y_g - v.h / 2
            v.y_g_max = v.y_g + v.h / 2
        }
        for (var k in pageConfig.branch_datas || table()) {
            var v = pageConfig.branch_datas[k]
            if(!v){
                continue
            }
            addToObjRef(v)
            v.name = pageConfig.resource[v.name]
            v.res_name = pageConfig.resource[v.res_name]
            v.y_g = v.y + min_y
            v.y_g_min = v.y_g - v.h / 2
            v.y_g_max = v.y_g + v.h / 2
        }
        min_y = min_y + pageConfig.scene_height
    }
    self.pageHeights = 0
    var $limit34 = self.getPageCount()
    for (var i = 1; i <= $limit34; i += 1) {
        var pageConfig = self.getPageConfig(i)
        self.pageHeights = self.pageHeights + pageConfig.scene_height
    }
}
HomeConfigManager.prototype.updateAnimData = function (page) {
    var self = this
    var min_y = 0
    var $limit40 = page - 1
    for (var i = 1; i <= $limit40; i += 1) {
        min_y = min_y + self.getPageConfig(i).scene_height
    }
    var $var42 = page,$limit43 = self.getPageCount()
    for (var i = $var42; i <= $limit43; i += 1) {
        var pageConfig = self.getPageConfig(i)
        var pageAnim = self.getPageAnim(i)
        for (var k in pageAnim) {
            var v = pageAnim[k]
            v.y_g = v.y + min_y
            v.y_g_min = v.y_g
            v.y_g_max = v.y_g + v.h
        }
        min_y = min_y + pageConfig.scene_height
    }
}
HomeConfigManager.prototype.getPageConfigsByOffset = function (viewSize, offset) {
    var self = this
    var configs = table()
    var min_y = 0
    var start = null
    var endNum = null
    var $limit55 = self.getPageCount()
    for (var i = 1; i <= $limit55; i += 1) {
        var pageConfig = self.getPageConfig(i)
        if (min_y - offset >= viewSize.height || min_y + pageConfig.scene_height <= 0) { } else {
            if (!start) {
                start = i
            }
            if (!endNum) {
                endNum = i
            } else if (endNum < i) {
                endNum = i
            }
            table.insert(configs, pageConfig)
        }
        min_y = min_y + pageConfig.scene_height
    }
    return [configs, start, endNum]
}
HomeConfigManager.prototype.getPageHeights = function () {
    var self = this
    return self.pageHeights
}
HomeConfigManager.prototype.getBranchPosition = function (groupId) {
    var self = this
    // body
    for (var k = 1, v = self.page_configs[1]; v; k++, v = self.page_configs[k]) {
        if (v.branch_datas) {
            for (var _k in v.branch_datas) {
                var _v = v.branch_datas[_k]
                if (_v.group_id === groupId) {
                    return [cc.p(_v.x, _v.y_g), _v.is_flip]
                }
            }
        }
    }
    return [cc.p(0, 0), false]
}
HomeConfigManager.prototype.getLevelNodePositionAndSize = function (levelId) {
    var self = this
    for (var k = 1, v = self.page_configs[1]; v; k++, v = self.page_configs[k]) {
        for (var i = 1, w = v.lv_datas[1]; w; i++, w = v.lv_datas[i]) {
            if (w.id === levelId) {
                // WARN: maybe multi result
                return [cc.p(w.x, w.y_g), cc.size(w.w, w.h)]
            }
        }
    }
    return [cc.p(0, 0), cc.size(0, 0)]
}

HomeConfigManager.prototype.getDataByInstanceId = function (id, type) {
    id = type(id) === "string" ? tonumber(id) : id;
    let num = self.getPageCount()
    for (var index = 0; index < num; index++) {
        var element = self.getPageConfig(index);
        var node_data
        switch(type){
            case he.NodeType.LV_DATA:
                node_data = element.lv_datas;
                break;
            case he.NodeType.BRANCH_DATA:
                node_data = element.branch_datas;
                break;
            case he.NodeType.OTHER_DATA:
                node_data = element.other_datas;
                break;
        }
        for (var key in node_data) {
            if (object.hasOwnProperty(key)) {
                var element = object[key];
                if(element.__hId === id){
                    return element;
                }
            }
        }
    }
    return null
}

HomeConfigManager.prototype.getLevelNodeData = function (levelId) {
    var self = this
    for (var k = 1, v = self.page_configs[1]; v; k++, v = self.page_configs[k]) {
        for (var i = 1, w = v.lv_datas[1]; w; i++, w = v.lv_datas[i]) {
            if (w.id === levelId) {
                // WARN: maybe multi result
                return clone(w)
            }
        }
    }
    return null
}
HomeConfigManager.prototype.getUnlockAreaNode = function (areaId) {
    var self = this
    // body
    return self.unlockMainConfig[areaId]
}
var hcm__ = null
HomeConfigManager.getInstance = function () {
    if (!hcm__) {
        hcm__ = HomeConfigManager.create()
    }
    return hcm__
}
